// import { MouseEvent } from 'react'
import { useState } from 'react'
import { FileInput } from 'components'
import { Icon } from 'assets/index'
import { UpImg, Image } from './style'

interface IUploadImgProps {
  children?: string
  onChangeFile?: (_file?: File) => void
  name?: string
  error?: string | boolean
  file?: File
}

const UploadImg = (props: IUploadImgProps) => {
  const [file, setFile] = useState<any>(props?.file)
  const { children, onChangeFile, name = 'uploadImg', error } = props
  return (
    <div style={{ position: 'relative' }}>
      <UpImg htmlFor="uploadImg" file={file} error={error}>
        <img className="ui-img" src={Icon('image.svg')} alt="img" />
        <span className="upload-text">{children}</span>
        <span className="upload-info">Máx: 10MB</span>
        {file ? (
          <div style={{ width: 19 }} />
        ) : (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            <img src={Icon('cloud.svg')} alt="cloud" className="ui-img" />
          </div>
        )}
        <FileInput
          className="ui-input"
          id="uploadImg"
          name={name}
          onChangeFile={(ev: any) => {
            setFile(ev)
            onChangeFile && onChangeFile(ev)
          }}
        />
      </UpImg>
      {file ? (
        <Image
          src={Icon('x_circle.svg')}
          alt="x"
          onClick={() => {
            setFile(false)
            onChangeFile && onChangeFile(undefined)
          }}
        />
      ) : (
        <div style={{ width: 19 }} />
      )}
    </div>
  )
}

export default UploadImg
